import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

export const RESOURCE_SCOPES = ['mine', 'shared'] as const;
export type ResourceScope = (typeof RESOURCE_SCOPES)[number];

/**
 * The scope every reader falls back to when no explicit scope is given.
 * Shared so a gallery and its URL persistence agree on what "absent" means.
 */
export const DEFAULT_RESOURCE_SCOPE: ResourceScope = 'mine';

const TRIGGER_CLASS =
  'h-9 flex-none rounded-md border-transparent bg-transparent px-3 py-1 text-sm font-medium text-muted-foreground shadow-none data-[state=active]:bg-muted data-[state=active]:text-foreground data-[state=active]:shadow-none data-[state=active]:border-transparent';

interface ScopeTabsProps {
  value: ResourceScope;
  onValueChange: (scope: ResourceScope) => void;
  /** Label for the caller's own items, e.g. "My chats". */
  mineLabel: string;
  sharedLabel?: string;
}

/**
 * The My/Shared switch used by list pages that support sharing. Shared so
 * the trigger styling has one home -- restyling it shouldn't mean finding
 * every page that grew a copy.
 */
export function ScopeTabs({
  value,
  onValueChange,
  mineLabel,
  sharedLabel = 'Shared with me',
}: ScopeTabsProps) {
  return (
    <Tabs
      value={value}
      onValueChange={(next) => onValueChange(next as ResourceScope)}
      className='gap-0'
    >
      <TabsList className='h-9 gap-1 rounded-none bg-transparent p-0'>
        <TabsTrigger value='mine' className={TRIGGER_CLASS}>
          {mineLabel}
        </TabsTrigger>
        <TabsTrigger value='shared' className={TRIGGER_CLASS}>
          {sharedLabel}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
